var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 14,
    viewBox: "0 0 28 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Battery"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Border",
    opacity: 0.35,
    x: 1.24265,
    y: 0.909646,
    width: 23.788,
    height: 11.894,
    rx: 3.76643,
    stroke: "#2C2C2C",
    strokeWidth: 0.991166
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cap",
    opacity: 0.4,
    d: "M26.4192 5.03906V9.00373C27.2168 8.66794 27.7355 7.88682 27.7355 7.02139C27.7355 6.15597 27.2168 5.37485 26.4192 5.03906Z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Capacity",
    x: 2.72986,
    y: 2.39453,
    width: 20.8145,
    height: 8.9205,
    rx: 2.47792,
    fill: "#2C2C2C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/Battery.e24865b7d3469df1bbac206d1d135124.svg";
export { ForwardRef as ReactComponent };